import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { setGoogleMapStatus } from 'src/redux/map.slice';

import { APP_FULL_NAME } from '../constants/common';
import { ROUTES } from '../constants/routes';
import type { RootState } from '../redux/store';
import { hasMenuPermission } from '../utils/permissions';

const PrivateRoute = ({ component: Component, title, ...props }: any) => {
    const isAuthenticated = useSelector((state: RootState) => state.auth.isAuthenticated);
    const currentUser = useSelector((state: RootState) => state.auth.currentUser);
    const appearance = useSelector((state: RootState) => state.basic.appearance);
    const { pathname } = window.location;
    const dispatch = useDispatch();

    const getPageName = (path: string) => {
        switch (path) {
            case ROUTES.HOME:
                return 'Home';
            case ROUTES.MY_QUOTE:
                return 'Shop';
            case ROUTES.RADAR:
                return 'Track';
            case ROUTES.ORDERS:
                return 'My Orders';
            case ROUTES.DOCUMENTATION_HUB:
                return 'Document Hub';
            case ROUTES.ORGANIZATION:
                return 'Organization';
            case ROUTES.ADDRESS_BOOK:
                return 'Address Book';
            case ROUTES.INTEGRATION:
                return 'Integrations';
            case ROUTES.SETTING:
                return 'Account Settings';
            default:
                return '';
        }
    };

    useEffect(() => {
        document.title = `${title} - ${appearance.web_title ?? APP_FULL_NAME}`;
        const favicon = document.getElementById('favicon') as HTMLLinkElement;

        // Only override the default favicon when the org has actually set one — otherwise keep the existing icon
        if (favicon && appearance?.favicon) {
            favicon.href = appearance.faviconUrl + appearance.favicon;
        }
    }, [title, appearance]);

    window.initMap = () => {
        dispatch(setGoogleMapStatus(true));
    };

    // Check authentication first
    if (!isAuthenticated) {
        return <Navigate to={ROUTES.LOGIN} />;
    }

    const pageName = getPageName(pathname);

    if (pageName && !hasMenuPermission(currentUser?.role, pageName)) {
        return <Navigate to={ROUTES.HOME} />;
    }

    return (
        <div className="overflow-hidden flex flex-col h-full">
            <div className="ml-0 h-full overflow-hidden">
                <div className="flex-grow overflow-y-auto custom-scrollbar-v2 flex flex-col h-full">
                    <Component {...props} />
                </div>
            </div>
        </div>
    );
};

export default PrivateRoute;
